export const DEFAULT_NODE_RADIUS = 0;
export const NODE_RADIUS_MIN = 0;
export const NODE_RADIUS_MAX = 32;

export function clampNodeRadius(value: number): number {
  return Math.round(Math.max(NODE_RADIUS_MIN, Math.min(NODE_RADIUS_MAX, value)));
}
